import { render, staticRenderFns } from "./subsection.vue?vue&type=template&id=cd7ae66a&scoped=true"
import script from "./subsection.vue?vue&type=script&lang=js"
export * from "./subsection.vue?vue&type=script&lang=js"
import style0 from "./subsection.vue?vue&type=style&index=0&id=cd7ae66a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd7ae66a",
  null
  
)

export default component.exports